import styled from '@emotion/styled';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.125rem 0.5rem;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 0.875rem;
  font-weight: bold;
  color: currentcolor;
`;

const Svg = styled.svg`
  display: block;
  width: 1.75rem;
  height: auto;
`;

export { Wrapper, Svg };
